import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

interface TabsContainerProps {
  theme: Theme
  leftAligned?: boolean
}

export const tabsContainer = ({ theme, leftAligned }: TabsContainerProps) => css`
  border: 1px solid ${theme.palette.grey[100]};
  border-radius: 4px;
  width: 100%;
  flex-grow: 1;

  & .MuiTabs-flexContainer {
    display: flex;
    flex: 1 1 auto;
    justify-content: ${leftAligned ? 'initial' : 'space-between'};
    ${leftAligned ? 'gap: 20px;' : ''}
  }

  ${leftAligned
    ? `.MuiTabScrollButton-root.Mui-disabled {
    width: 16px;
  }
    .MuiTab-root {
      min-width: 0;
    }`
    : ''}
`

export const tabsMenuContainer = ({ theme, color }: { theme: Theme; color: string }) => css`
  border-bottom: 1px solid ${theme.palette.grey[100]};
  color: ${color};
  width: 100%;
  display: flex;
`

export const tabMenuTitle = ({ theme }: { theme: Theme }) => css`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  font-weight: 700;
  transition: color 0.6s;

  &[aria-selected='true'] {
    color: ${theme.palette.primary.main};
  }

  &[aria-selected='false'] {
    color: ${theme.palette.secondary[800]};
  }

  &[disabled] {
    color: ${theme.palette.grey[200]};
  }

  & * {
    & .MuiTabs-scrollableX {
      flex-grow: 0;
    }
  }
`

export const headerButtonsBox = () => css`
  display: flex;
  gap: 4px;
  padding: 4px 8px;
  margin-left: auto;
  align-items: center;
  align-self: flex-end;
  flex-grow: 0;
`

export const tabsMenu = () => css`
  flex-grow: 1;
`
